<b-tabs type="is-boxed" v-model="activeTab">
	<template v-for="(tab, index) in tabs" :key="tab.id">
		<b-tab-item :label="tab.name" :value="tab.id" :icon="tab.icon">
			<Fragment :fragment="tab.fragment" />
		</b-tab-item>
	</template>
</b-tabs>
